import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import MiseAtHome from "@/pages/MiseAtHome";
import FamilyMeals from "@/pages/FamilyMeals";
import FamilyMealsJoin from "@/pages/FamilyMealsJoin";
import FamilyMealsComingSoon from "@/pages/FamilyMealsComingSoon";
import HeartOfHouse from "@/pages/HeartOfHouse";
import HohPilotForm from "@/pages/HohPilotForm";
import HohPilotProgram from "@/pages/HohPilotProgram";
import HeartOfHouseDemo from "@/pages/HeartOfHouseDemo";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Media from "@/pages/Media";
import MediaPost from "@/pages/MediaPost";
import AdminMedia from "@/pages/AdminMedia";
import AdminImpact from "@/pages/AdminImpact";
import AdminAnalytics from "@/pages/AdminAnalytics";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/at-home" element={<MiseAtHome />} />
              <Route path="/family-meals" element={<FamilyMeals />} />
              <Route path="/family-meals/join" element={<FamilyMealsJoin />} />
              <Route path="/family-meals/coming-soon" element={<FamilyMealsComingSoon />} />
              <Route path="/heart-of-house" element={<HeartOfHouse />} />
              <Route path="/heart-of-house/pilot" element={<HohPilotProgram />} />
              <Route path="/heart-of-house/pilot/apply" element={<HohPilotForm />} />
              <Route path="/heart-of-house/demo" element={<HeartOfHouseDemo />} />
              <Route path="/about" element={<About />} />
              <Route path="/media" element={<Media />} />
              <Route path="/media/:slug" element={<MediaPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/admin/impact" element={<AdminImpact />} />
              <Route path="/admin/analytics" element={<AdminAnalytics />} />
              <Route path="/admin/media" element={<AdminMedia />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
